/**
 * DriverOperationalBanner — Phase 43.27
 *
 * Banner COMPATTO mostrato in cima a "Ordini disponibili" SOLO se il driver
 * non è operativo (onboarding incompleto, documenti scaduti, account sospeso).
 *
 * Non mostra la checklist completa: rimanda al Profilo driver dove la
 * checklist vive a tempo pieno.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, FileWarning } from "lucide-react";
import { api } from "@/lib/api";

export default function DriverOperationalBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/driver/onboarding-status");
        if (!cancelled) setStatus(data);
      } catch {/* silently */}
    })();
    return () => { cancelled = true; };
  }, []);

  if (!status) return null;
  if (status.ready) return null;  // Profilo operativo → niente banner

  // Compliance bloccata (es. documenti scaduti) ha priorità sul copy
  const compBlocked = status?.compliance?.blocked === true;
  const nextBlocker = status?.next_blocker;
  const isComplianceBlock = compBlocked;

  return (
    <div
      data-testid="driver-operational-banner"
      className="rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 flex items-center gap-3 text-sm text-amber-900"
    >
      {isComplianceBlock ? (
        <FileWarning className="size-5 shrink-0 text-amber-700" />
      ) : (
        <AlertCircle className="size-5 shrink-0 text-amber-700" />
      )}
      <div className="flex-1 min-w-0">
        <p className="font-semibold leading-tight">
          {isComplianceBlock
            ? "Documento scaduto: aggiorna patente o assicurazione per tornare operativo."
            : "Completa il profilo per ricevere e accettare ordini."}
        </p>
        {!isComplianceBlock && status.progress_pct != null && (
          <p className="text-xs text-amber-900/80 mt-0.5">
            Profilo completo al <strong>{status.progress_pct}%</strong>
            {nextBlocker?.label ? ` · prossimo passo: ${nextBlocker.label}` : ""}
          </p>
        )}
      </div>
      <Link
        to="/driver/profile"
        data-testid="driver-operational-banner-cta"
        className="h-10 px-4 rounded-xl bg-amber-700 text-white text-xs font-semibold hover:bg-amber-800 flex items-center gap-1.5 shrink-0"
      >
        {isComplianceBlock ? "Aggiorna documenti" : "Vai al profilo"}
        <ArrowRight className="size-3.5" />
      </Link>
    </div>
  );
}
